import React from 'react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  totalItems: number
  pageSize: number
  onPageChange: (page: number) => void
  onItemsPerPageChange: (itemsPerPage: number) => void
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  onItemsPerPageChange
}) => {
  return (
    <div className='pagination-section mt-50 mb-30'>
      <div className='row align-items-center'>
        <div className='col-12'>
          <div className='pagination-info-wrapper text-center mb-4'>
            <div className='pagination-current-page'>
              <span className='badge badge-pill badge-primary px-4 py-2 current-page-large'>
                <span className='page-indicator'>Strona</span> <strong className='page-number'>{currentPage}</strong> <span className='page-indicator'>z</span> <strong className='page-number'>{totalPages}</strong>
              </span>
            </div>
            <div className='pagination-total-info mt-2'>
              Wyświetlanie <strong>{totalItems > 0 ? (currentPage - 1) * pageSize + 1 : 0}</strong> - <strong>{Math.min(currentPage * pageSize, totalItems)}</strong> z <strong>{totalItems}</strong> roślin
            </div>
          </div>

          {totalPages > 1 && (
            <nav aria-label='Nawigacja strony roślin' className='product-pagination'>
              <ul className='pagination pagination-lg justify-content-center'>
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <a
                    className='page-link'
                    href='#'
                    onClick={(e) => {
                      e.preventDefault()
                      if (currentPage > 1) onPageChange(currentPage - 1)
                    }}
                    aria-label='Poprzednia'
                  >
                    <span aria-hidden='true'>&laquo;</span>
                    <span className='sr-only'>Poprzednia</span>
                  </a>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(page =>
                    page === 1 ||
                        page === totalPages ||
                        (page >= currentPage - 2 && page <= currentPage + 2)
                  )
                  .map((page, index, array) => {
                    const showEllipsisBefore = index > 0 && array[index - 1] !== page - 1
                    const showEllipsisAfter = index < array.length - 1 && array[index + 1] !== page + 1

                    return (
                      <React.Fragment key={page}>
                        {showEllipsisBefore && (
                          <li className='page-item disabled'>
                            <span className='page-link'>...</span>
                          </li>
                        )}

                        <li className={`page-item ${page === currentPage ? 'active' : ''}`}>
                          <a
                            className='page-link'
                            href='#'
                            onClick={(e) => {
                              e.preventDefault()
                              onPageChange(page)
                            }}
                          >
                            {page}
                          </a>
                        </li>

                        {showEllipsisAfter && (
                          <li className='page-item disabled'>
                            <span className='page-link'>...</span>
                          </li>
                        )}
                      </React.Fragment>
                    )
                  })}

                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <a
                    className='page-link'
                    href='#'
                    onClick={(e) => {
                      e.preventDefault()
                      if (currentPage < totalPages) onPageChange(currentPage + 1)
                    }}
                    aria-label='Następna'
                  >
                    <span aria-hidden='true'>&raquo;</span>
                    <span className='sr-only'>Następna</span>
                  </a>
                </li>
              </ul>
            </nav>
          )}

          <div className='items-per-page-selector-wrapper text-center mt-4'>
            <div className='items-per-page-selector d-inline-block'>
              <label className='mr-2'>Roślin na stronie:</label>
              <select
                className='form-control form-control-sm d-inline-block w-auto'
                value={pageSize}
                onChange={(e) => {
                  const newItemsPerPage = parseInt(e.target.value, 10)
                  onItemsPerPageChange(newItemsPerPage)
                }}
              >
                <option value='12'>12</option>
                <option value='24'>24</option>
                <option value='48'>48</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Pagination
